import React from 'react';
import useNumberDraft from './useNumberDraft';
import { StyledNumberField } from './index.style';

// Ô số chiếm trọn cột control, không có đơn vị đi kèm.
const NumberField = ({ width, value, range, disabled, onChange }) => {
  const draft = useNumberDraft(value, range, onChange);

  return <StyledNumberField $width={width} disabled={disabled} {...draft} />;
};

export default NumberField;
